import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {PageTitleService} from "../../services/PageTitle";
import {Session} from "../../services/Session";
import {takeUntil} from "rxjs/operators";
import {StateService} from "../../services/StateService";
import {Router} from "@angular/router";
import {LoadingService} from "../../services/LoadingService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ToastService} from "../../services/Toast.service";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";

declare let jQuery: any;

@Component({
  selector: 'app-manage-billing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './manage-billing.component.html',
  styleUrl: './manage-billing.component.scss'
})
export class ManageBillingComponent implements OnInit, OnDestroy {

  org: string;
  userId: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  activeTab: string = 'billing-subscription';
  selectedFrequency = '';
  subscriptionData: any;
  subscription: any;
  subscriptionMessage = '';
  activePromoCode = '';
  promoCode = '';
  promoValid: any;
  showPromoMessage = false;
  promoInvalidMessage = 'Invalid promo code';

  constructor(private titleService: PageTitleService, private stateService: StateService, private _router: Router,
              private loadingService: LoadingService, private switchBoard: SwitchBoard, private toastService: ToastService,
              private taxPlanningService: TaxPlanningService) {
  }

  ngOnInit() {
    this._init();
  }

  _init() {
    this.org = Session.getOrg();
    this.userId = Session.getUser().id;
    this.titleService.setPageTitle('Manage Billing');
    this.getPaymentDetails();
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
  }

   openManageBillingWidget(){
    this.getPaymentDetails();
  }

  getPaymentDetails() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getUserSingleSignOnInfo(this.org, this.userId, {})
      .subscribe(response => {
        if(response && response.portalUrl){
            const url = response.portalUrl;
            const windowName = '_blank';
            window.open(url, windowName);
          }
        this.loadingService.triggerLoadingEvent(false);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to perform operation');
      });
  }


  getSubscriptionDetails() {
    this.taxPlanningService.getSubscriptionData(this.org, this.userId)
      .subscribe(response => {
        this.subscriptionData = response;
        this.subscription = response.subscription || {frequency: '', amount: ''};
        this.activePromoCode = response.activePromoCode;
        this.selectedFrequency = this.subscription.frequency;
        this.populateSubscriptionMessage(response);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to get subscription info');
      });
  }

  populateSubscriptionMessage(data) {
    if (data) {
      this.subscriptionMessage = (data.yearlyMessage) ? data.yearlyMessage : '';
    }
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    if (prevState) {
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isTabActive(tab) {
    return this.activeTab === tab;
  }

  setActiveTab(tab) {
    this.resetSection();
    jQuery("#p-"+tab).attr("aria-selected","true");
    this.activeTab = tab;
  }

  resetSection() {
    jQuery("#p-billing-subscription").attr("aria-selected","false");
    jQuery("#p-update-billing").attr("aria-selected","flase");
  }

  updateSubscription() {
    let data = {};
    data['frequency'] = 'yearly';
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateSubscriptionData(this.org, this.userId, data)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Subscription updated successfully');
        this.getSubscriptionDetails();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.error, 'Failed to update subscription');
      });
  }

  validatePromoCode() {
    if (this.promoCode) {
      const data = {};
      data['code'] = this.promoCode;
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.applyPromoCode(this.org, this.userId, data).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.showPromoMessage = true;
        this.promoValid = true;
        this.toastService.pop(TOAST_TYPE.success, 'Applied Successfully');
        setTimeout(() => {
          this.getSubscriptionDetails();
        }, 300);

      }, error =>  {
        this.showPromoMessage = true;
        this.promoValid = false;
        try {
          this.promoInvalidMessage = error.message ? error.message : this.promoInvalidMessage;
        } catch (e) {
          this.promoInvalidMessage = 'Invalid promo code';
        }
        this.loadingService.triggerLoadingEvent(false);
      });
    } else {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter a promo code.');
    }
  }

  onLoadChargeBeePortal() {
    const base = this;
    setTimeout(function () {
      base.loadingService.triggerLoadingEvent(false);
    }, 3000);
  }

}
